import { configure } from '@m1/geo-utils';
import React from 'react';
import ReactDOM from 'react-dom/client';

import './styles/global.scss';
import App from './App';
import { GOOGLE_API_KEY, GOOGLE_GEOCODING_URL } from './config';
import reportWebVitals from './reportWebVitals';

configure({
  elevationBaseUrl: process.env.REACT_APP_ELEVATION_BASE_URL,
  googleApiKey: GOOGLE_API_KEY,
  googleGeocodingUrl: GOOGLE_GEOCODING_URL,
});

const title = process.env.REACT_APP_TITLE;
if (title) {
  document.title = title;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
